import { Flex } from "@simplybusiness/mobius";
import type { MutableRefObject } from "react";
import { PaymentToggle } from "../../../../shared/PaymentToggle";
import type { Quote } from "../../../types";
import { Pricing } from "../../Pricing";
import { SubmissionForm } from "./SubmissionForm/SubmissionForm";

type Props = {
  quote: Quote;
  paymentInformationRef?: MutableRefObject<HTMLDivElement | null>;
  hasInstallments: boolean;
};

export const Footer = ({
  quote,
  paymentInformationRef,
  hasInstallments,
}: Props) => {
  function scrollToPaymentInformation() {
    paymentInformationRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }
  const showPaymentInformation = !quote.offlinePurchaseOnly;

  return (
    <Flex
      className="mobius-quote-details-drawer__footer"
      flexDirection="column"
    >
      <Flex className="mobius-quote-details-drawer__footer-payment-info">
        {hasInstallments && (
          <PaymentToggle data-test-id="footer-payment-toggle" />
        )}
        <Pricing quote={quote} displayVariant="qds" />
      </Flex>
      {showPaymentInformation && (
        <button
          className="mobius-quote-details-drawer__footer-payment-info-link"
          onClick={() => scrollToPaymentInformation()}
        >
          See payment information
        </button>
      )}

      <SubmissionForm quote={quote} hasInstallments={hasInstallments} />
    </Flex>
  );
};
